module.exports = __webpack_public_path__ + "img/ribbon.49be03aa.png";